export interface NavLeaf {
  id: string
  label: string
  path: string
  iconName: string
}

export interface NavGroup {
  id: string
  label: string
  iconName: string
  children: NavLeaf[]
}

export interface NavSection {
  id: string
  label?: string
  kind: "section"
  children: Array<NavLeaf | NavGroup>
}

export type NavNode = NavLeaf | NavGroup | NavSection

export const isNavSection = (node: NavNode): node is NavSection =>
  (node as NavSection).kind === "section"

export const isNavGroup = (node: NavNode): node is NavGroup =>
  !isNavSection(node) && Array.isArray((node as NavGroup).children)
